// „Care membru ești tu?" — afișat cât timp contul tău nu e legat de niciun membru din grup.
export function ClaimPrompt({ members, onClaim }) {
  return (
    <div data-testid="claim-prompt" className="mt-3 rounded-2xl border border-slate-200 bg-white p-4">
      <p className="text-sm font-semibold text-slate-700 mb-2">Care membru ești tu?</p>
      <div className="flex flex-wrap gap-2">
        {members
          .filter((m) => !m.userId)
          .map((m) => (
            <button
              key={m.id}
              data-testid={`claim-me-${m.id}`}
              onClick={() => onClaim(m.id)}
              className="px-3 py-1.5 rounded-full text-sm font-semibold bg-slate-100 text-slate-600 hover:bg-emerald-100 hover:text-emerald-700 transition-colors"
            >
              Eu sunt {m.name}
            </button>
          ))}
      </div>
    </div>
  );
}
